import MarkerClusterer from '@googlemaps/markerclustererplus';

function acfMap(){

(function( $ ) {
    var infoWindows = [];
    var allMarkers = [];
    var iconPin;
    var iconPinHov;
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {
        iconPin = $el.data('iconpin');
        iconPinHov = $el.data('iconpinhov');
        // Find marker elements within map.
        var $markers = $el.find('.marker');
    
        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false

        };
        var map = new google.maps.Map( $el[0], mapArgs );
        
        google.maps.event.addListener(map, 'click', function() {
            closeAllInfoWindows();
        });
        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });
    
        // Center map based on markers.
        centerMap( map );

        var markerCluster = new MarkerClusterer(map, map.markers,
            {imagePath: ''});

    
        // Return map instance.
        return map;
        
    }
    
    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map) {
    
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var single = $marker.data('single');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };
    
        // Create marker instance.
        
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            icon: {
                url: iconPin
            }
        });
    
        // Append to reference for later use.
        map.markers.push( marker );
        allMarkers.push( marker );
        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){
            
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
                maxWidth: 298,
                position : latLng
            });

            infoWindows.push(infowindow);
            
            if(single == 'yes'){
                infowindow.open(map);
            }
            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                closeAllInfoWindows();
                infowindow.open(map);
                marker.setIcon({
                    url: iconPinHov
                });
                marker.setOpacity(0.99);
            });
            google.maps.event.addListener(marker, "mouseover", function() {
                marker.setIcon({
                    url: iconPinHov
                });
            });
            google.maps.event.addListener(marker, "mouseout", function() {
                if (marker.getOpacity() == 0.99){
                }else{
                    marker.setIcon(iconPin);
                }
            });
        }
    }
    
    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {
    
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });
    
        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );
            setTimeout(() => map.panBy(0, 50), 500);
        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }
    
    function closeAllInfoWindows() {
        for (var i=0;i<infoWindows.length;i++) {
           infoWindows[i].close();
        }
        allMarkers.forEach(function( marker ){
            marker.setOpacity(1);
            marker.setIcon({
                url: iconPin
            });
        });
    }

    // Render maps on page load.
    $(document).ready(function(){
        $('.acf-map').each(function(){
            var map = initMap( $(this) );
        });
    });

    

})(jQuery);
}

module.exports = acfMap;